import React from 'react'
import * as R from 'remeda'

import {
  EditDiffButton,
  type EditDiffButtonProps,
} from '~/components/features/EditDiffButton'
import { type GroupAndAll } from '~/utils'

import { useTabulatedGroupsAndAll } from '../hooks/useTabulatedGroupsAndAll'
import { useAtomContext } from '../providers/AtomsProvider'
import { type GroupsDiff } from '../utils'

import { GroupSelector } from './GroupSelector'

export const EditGroupsDiffButton = () => {
  const tabulatedGroupsAndAll = useTabulatedGroupsAndAll()
  const renderSelector = React.useMemo<EditDiffButtonProps['renderSelector']>(
    () => (field, anotherFieldValue) => (
      <GroupSelector
        {...field}
        groups={R.difference(tabulatedGroupsAndAll, [
          anotherFieldValue as GroupAndAll,
        ])}
        value={field.value as GroupAndAll | null}
      />
    ),
    [tabulatedGroupsAndAll],
  )

  const [groupsDiffs, setGroupsDiffs] = useAtomContext('groupsDiffs')
  const handleExecute = React.useCallback<EH<EditDiffButtonProps, 'onExecute'>>(
    (diffs) => {
      setGroupsDiffs(diffs as GroupsDiff[])
    },
    [setGroupsDiffs],
  )

  return (
    <EditDiffButton
      diffs={groupsDiffs}
      renderSelector={renderSelector}
      onExecute={handleExecute}
    />
  )
}
